import { http } from 'utils'

import { Report2CreateFormTypes, Report2APISchemas} from "schemas/reports-#-2-schemas"

export const  postReport2Service = async(payload: Report2CreateFormTypes) => {

    const url = `/merchant/transactions-report`
    const response = await http.post(url, payload)
    const result = Report2APISchemas.safeParse(response.data)
    if (!result.success) 
      throw result.error
    return result.data
}
